import { render, staticRenderFns } from "./ScrollableDialog.vue?vue&type=template&id=f17bbb76&scoped=true"
import script from "./ScrollableDialog.vue?vue&type=script&lang=js"
export * from "./ScrollableDialog.vue?vue&type=script&lang=js"
import style0 from "./ScrollableDialog.vue?vue&type=style&index=0&id=f17bbb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17bbb76",
  null
  
)

export default component.exports